import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioClassificacaoPorAssuntoReducer(state = initialState.relatorioClassificacaoPorAssunto, action){
    switch(action.type) {
        case types.RELAT_CLASSIFICACAO_ESTRUTURA_POR_ASSUNTO:
            
            return action.relatorioClassificacaoPorAssunto;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioClassificacaoPorAssuntoReducer.js
 **/